import { z } from "zod";
import { formatBytes } from "./formatting";

z.config({
  customError(issue) {
    if (
      issue.code === "too_small" &&
      issue.origin === "string" &&
      issue.minimum === 1
    ) {
      return "This field is required";
    }
  },
});

export const requiredString = z.string().trim().min(1);

type FileSchemaBuilder<T extends File | undefined = File | undefined> =
  z.ZodType<T> & {
    maxSize(bytes: number): FileSchemaBuilder<T>;
    format(types: string[]): FileSchemaBuilder<T>;
  };

function buildFileSchema<T extends File | undefined>(
  schema: z.ZodType<T>,
): FileSchemaBuilder<T> {
  return Object.assign(schema, {
    maxSize(bytes: number): FileSchemaBuilder<T> {
      return buildFileSchema(
        schema.refine(
          (file) => !file || (file as File).size <= bytes,
          `File exceeds the ${formatBytes(bytes)} limit.`,
        ),
      );
    },
    format(types: string[]): FileSchemaBuilder<T> {
      return buildFileSchema(
        schema.refine(
          (file) => !file || types.includes((file as File).type),
          "Invalid file type.",
        ),
      );
    },
  }) as FileSchemaBuilder<T>;
}

export const file = (): FileSchemaBuilder<File | undefined> =>
  buildFileSchema(z.custom<File>().optional());
